import { FormGroup, Label } from './styles/common';

export function FormInputTextarea({
  label, placeholder, rows, registration, error, valid, max, value,
  // Optional note under the field. Marks a value filled in from an uploaded document,
  // so the user knows to check it rather than assume we got it right.
  // See FormInputText: marks a value that came from an uploaded document.
  hint,
}) {
  return (
    <FormGroup>
      {label !== undefined
        && <Label>{label}</Label>}
      <textarea
        placeholder={placeholder}
        rows={rows}
        maxLength={max}
        value={value}
        className={`form-control text-center ${valid ? 'is-valid' : ''} ${error ? 'is-invalid' : ''}`}
        {...registration}
      />
      <div className="invalid-feedback">
        {error}
      </div>
      {hint && <p className="form-input-hint">{hint}</p>}
    </FormGroup>
  );
}
